import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PermissionsService } from './permissions.service';

// Generyczny guard trasowy - czyta route.data.permissionKey (+ opcjonalnie
// permissionLevel, domyslnie 'read') i sprawdza w PermissionsService.
// Zastępuje OwnerOnlyGuard - dowolna trasa może być gate'owana bez pisania
// nowego guarda, wystarczy dopisać klucz węzła w routing module.
@Injectable({ providedIn: 'root' })
export class PermissionGuard {
  constructor(
    private readonly permissionsService: PermissionsService,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const resourceKey = route.data?.['permissionKey'] as string | undefined;
    const level = (route.data?.['permissionLevel'] as 'read' | 'write') ?? 'read';

    // permissionsService.ensureLoaded() czeka na pierwszy refresh(), zanim
    // guard cokolwiek zdecyduje - bez tego trasa otwarta w NOWEJ karcie
    // (np. link "otworz w nowym oknie") mogla trafic na guard ZANIM
    // AppComponent.ngOnInit() zdazyl doladowac mape uprawnien, i przekierowac
    // na home mimo pelnego dostepu (zgloszenie 25.08).
    return this.permissionsService.ensureLoaded().pipe(
      map(() => {
        if (!resourceKey) {
          // Brak klucza w konfiguracji trasy = błąd dewelopera, nie usera -
          // przepuszczamy, żeby nie zablokować tras, które nie zostały jeszcze
          // podłączone pod nowy system (Faza 2).
          return true;
        }

        if (this.permissionsService.has(resourceKey, level)) {
          return true;
        }

        this.router.navigate(['/']);
        return false;
      }),
    );
  }
}
